module.exports = {
  QUICK: 'quick',
  INVITED: 'invited',
};



// WEBPACK FOOTER //
// ./src/constants/SignUpTypes.js